'use strict'

export const header = (() => {
    let headerElement
    let root

    const setHeaderVar = () => {
        if (!headerElement) return

        const headerStyles = window.getComputedStyle(headerElement)

        if (headerStyles.getPropertyValue('position') == 'fixed') {
            root.style.setProperty('--header-height', '0px')
        } else {
            root.style.setProperty('--header-height', headerElement.offsetHeight + 'px')
        }

        root.style.setProperty('--header-fixed-height', headerElement.offsetHeight + 'px')
    }

    const setImportantMinHeight = () => {
        const sectionsWithImportant = document.querySelectorAll('[data-min-height-by-important]')

        sectionsWithImportant.forEach(section => {
            const importantBlock = section.querySelector('[data-important]')

            if (!importantBlock) return

            section.style.setProperty('--important-height', importantBlock.offsetHeight + 'px')
        })

    }

    const allSets = () => {
        setHeaderVar()
        setImportantMinHeight()
    }

    const init = () => {
        headerElement = document.querySelector('body > header')
        root = document.querySelector(':root')

        if (!headerElement) return

        window.addEventListener('resize', allSets)

        setTimeout(allSets, 10)
    }

    return {
        init
    }
})()